/* Phones: photo at the left of the copy; from 1024 px a grid of four cards,
   photo on top. */
.grid {
  margin: 0;
  padding: 0;
  list-style: none;
  display: grid;
  gap: 14px;
}

.card {
  display: flex;
  gap: 14px;
  background: var(--card);
  border-radius: var(--radius-card);
  overflow: hidden;
  box-shadow: var(--shadow-card);
}

/* No box of its own: the <img> stays the card's flex item. */
.picture {
  display: contents;
}

.photo {
  display: block;
  flex: none;
  width: 88px;
  /* Not the height attribute's 240 px: the card's height (min-height). */
  height: auto;
  min-height: 100%;
  object-fit: cover;
  background: var(--band);
}

.noPhoto {
  background: var(--border-strong);
}

.body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 14px 14px 12px 0;
}

.count {
  margin: 0;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 0.22em;
  text-transform: uppercase;
  color: var(--label);
}

.title {
  margin: 0;
  font-family: var(--font-display);
  font-weight: 600;
  /* 20 px and the 88 px photo keep "Достопримечательности" (~200 px) on one
     line from 360 px phones up — Chrome on Windows doesn't hyphenate Russian. */
  font-size: 20px;
  line-height: 1.1;
  hyphens: auto;
  overflow-wrap: break-word;
}

.text {
  margin: 0;
  font-size: 13px;
  line-height: 1.55;
  color: var(--text-secondary);
}

.more {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 44px;
  margin-top: auto;
  font-size: 13px;
  font-weight: 500;
  color: var(--primary);
}

@media (min-width: 1024px) {
  .grid {
    grid-template-columns: repeat(4, minmax(0, 1fr));
    gap: 20px;
  }

  .card {
    flex-direction: column;
    gap: 0;
  }

  .photo {
    width: 100%;
    height: 190px;
    min-height: 0;
  }

  .body {
    gap: 8px;
    padding: 18px 20px 10px;
  }

  .title {
    font-size: 27px;
  }

  .text {
    font-size: 14px;
  }

  .more {
    font-size: 14px;
  }
}
